import {createSlice} from '@reduxjs/toolkit';
const initialState = {
    hasErrored:false,
    errorMsg:null
}
export const errorSlice = createSlice({
    name:"error",
    initialState,
    reducers:{
        setHasErrored: (state,action) => {
            state.hasErrored = action.payload
        },
        setErrorMsg: (state,action) => {
            state.errorMsg = action.payload
        }
    }
});

export const {setErrorMsg,setHasErrored} = errorSlice.actions;
export default errorSlice.reducer;